@if (loading$ | async) {
  <div class="app-loading">
    <div class="app-loading__bar"></div>
  </div>
}
<router-outlet />
